import React, { Fragment, useState } from "react";
import { SketchPicker } from "react-color";

export default function ColorPicker(props) {
  const { value, onChange } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState(value || {});
  const handleClick = () => setDisplayColorPicker(!displayColorPicker);
  const handleClose = () => setDisplayColorPicker(false);
  const handleChange = (value) => setColor(value.hex);
  const handleChangeComplete = (value) => {
    setColor(value.hex);
    onChange(value.hex);
  };
  return (
    <Fragment>
      <button
        aria-labelledby={props["aria-labelledby"]}
        className="color-picker-swatch"
        onClick={handleClick}
        type="button"
      >
        <div className="color-picker-color" style={{ background: color }} />
      </button>
      {displayColorPicker && (
        <div className="color-picker-popover">
          {/* oxlint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- This pointer-only backdrop dismisses the popover; the swatch remains the keyboard control. */}
          <div className="color-picker-cover" onClick={handleClose} />
          <SketchPicker color={color} onChange={handleChange} onChangeComplete={handleChangeComplete} />
        </div>
      )}
    </Fragment>
  );
}
